import React from 'react';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import ModernDatePicker from 'src/components/SharedComponents/ModernDatePicker/ModernDatePicker';

interface KeyDatesSectionProps {
  orientationDate: any;
  completionDate: any;
  posessionDate: any;
  isSparkDisabled: boolean;
  onChangeOrientationDate: (date: Date | null) => void;
  onChangeCompletionDate: (date: Date | null) => void;
  onChangePossessionDate: (date: Date | null) => void;
}

const KeyDatesSection = ({
  orientationDate,
  completionDate,
  posessionDate,
  isSparkDisabled,
  onChangeOrientationDate,
  onChangeCompletionDate,
  onChangePossessionDate,
}: KeyDatesSectionProps) => {
  return (
    <>
      <h2>Key Dates</h2>
      <Row>
        <Col xs="12" md="4">
          <ModernDatePicker
            label="Orientation Date"
            labelAlign="left"
            value={orientationDate ?? null}
            onChange={(date: Date | null) => onChangeOrientationDate(date)}
            disabled={isSparkDisabled}
          />
        </Col>
        <Col xs="12" md="4">
          <ModernDatePicker
            label="Completion Date"
            labelAlign="left"
            value={completionDate ?? null}
            onChange={(date: Date | null) => onChangeCompletionDate(date)}
            disabled={isSparkDisabled}
          />
        </Col>
        <Col xs="12" md="4">
          <ModernDatePicker
            label="Possession Date"
            labelAlign="left"
            value={posessionDate ?? null}
            onChange={(date: Date | null) => onChangePossessionDate(date)}
            disabled={isSparkDisabled}
          />
        </Col>
      </Row>
    </>
  );
};

export default KeyDatesSection;
